import manufactureImg from "../assets/manufacture.png";
import { motion } from "framer-motion";
import factoryImage from "../assets/factory-image.webp";
import circleBg from "../assets/circle-bg.svg";
import iconAutomationBlue from "../assets/icon-automation-blue.svg";
import iconAutomationWhite from "../assets/icon-automation-white.svg";
import iconTestingBlue from "../assets/icon-testing-blue.svg";
import iconTestingWhite from "../assets/icon-testing-white.svg";
import globeImg from "../assets/global-standards.webp";
import smartFactoryImg from "../assets/smart-manufacturing.png";
import chartImg from "../assets/speed-scale.png";
import { Helmet } from "react-helmet-async";

import { useState, useEffect, useRef } from "react";

const ManufactureHero = () => {

  // const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        // setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [word, setWord] = useState('Today');

  useEffect(() => {
    const interval = setInterval(() => {
      setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>Advanced Manufacturing Solutions | Smart & Efficient Production</title>
        <meta name="description" content="Empower your business with LENTERA’s technology-led manufacturing solutions. From design and prototyping to assembly, quality testing and global delivery, we provide reliable, high-quality and smart production for scalable growth. " />

        <meta name="keywords" content="LENTERA manufacturing services, global manufacturing standards, end-to-end manufacturing process, automated production." />
      </Helmet>

      <section className="w-full bg-[#FFF0EF] py-20 px-4 sm:px-6">
        <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

          {/* Left Column – 60% with animation */}
          <motion.div
            className="w-full lg:w-[60%]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h5 className="text-[#212129] text-sm font-medium uppercase mb-3 tracking-wide">
              Manufacturing
            </h5>

            <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
              Making products using <br />
              machines and labor.
            </h2>

            <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
              Manufacturing is the process of converting raw materials into finished   <br /> goods using machinery, tools and labor.
            </p>
          </motion.div>

          {/* Right Column – 40% with animation */}
          <motion.div
            className="w-full lg:w-[40%] flex justify-center"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >

            <img
              src={manufactureImg}
              alt="Manufacture Illustration"
              className="w-[380px] sm:w-[460px] md:w-[520px] lg:w-full max-w-[600px] h-auto object-contain"
            />
          </motion.div>
        </div>
      </section>
      
      <section className="w-full flex justify-center px-7 md:px-8 lg:px-8 py-12">
        {/* Card Container with fixed width & rounded corners */}
        <div className="relative w-[1412px] rounded-[48px] overflow-hidden px-10 md:px-16 py-14 flex flex-col lg:flex-row items-center justify-between gap-10 bg-[#212129]">

          {/* Blurred Background Layer */}
          <div
          // className="absolute inset-0 z-0"
          // style={{
          //   backgroundImage: `url(${patternBg})`,
          //   backgroundSize: "cover",
          //   backgroundPosition: "center",
          //   filter: "blur(5px)",     // Adjust blur as needed
          //   opacity: 0.4,             // Optional: adjust visibility
          // }}
          />

          {/* Main Content (above blur) */}
          <div className="relative z-10 w-full lg:w-[50%] flex justify-center">
            <img
              src={factoryImage}
              alt="Factory"
              className="max-w-full h-auto"
            />
          </div>

          <div className="relative z-10 w-full lg:w-[50%] text-white">
            <div className="bg-[#3F3F3F] inline-block text-sm font-medium px-5 py-2 rounded-full mb-4">
              Let’s build something great together
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">
              Empowering industry<br />through excellence
            </h2>
            <p className="text-base sm:text-lg text-[#D4D4D4] max-w-xl">
              We are a technology-led manufacturing company focused on delivering
              reliable, efficient and customized production solutions. With a
              commitment to innovation and quality, we help businesses scale with
              confidence.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#FAFAFA]">
        <div className="bg-white rounded-t-[48px] px-4 sm:px-6 md:px-10 lg:px-20 py-20 overflow-hidden">
          <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-16 relative">

            {/* Left Content */}
            <div className="max-w-xl text-center lg:text-left z-10">
              <div className="inline-block px-6 py-2 rounded-full bg-[#EDEDED] text-[#1A1A1A] text-sm font-medium mb-6">
                KNOW ABOUT US
              </div>
              <h2 className="text-[32px] sm:text-[36px] md:text-[44px] font-bold text-[#1A1A1A] mb-4 leading-tight">
                What We Do
              </h2>
              <p className="text-[#3F3F3F] text-base sm:text-lg leading-relaxed">
                We handle everything from design and prototyping to production,
                assembly and global delivery—ensuring a smooth, end-to-end manufacturing process.
              </p>
            </div>

            {/* Right Cards Container */}
            <div className="relative w-full max-w-[480px] h-[480px] sm:h-[440px] mx-auto z-10">

              {/* Rotating Background */}
              <img
                src={circleBg}
                alt="Circle Background"
                className="absolute w-[200px] h-[200px] left-1/2 -translate-x-1/2 top-[120px] animate-spin-slow opacity-60 z-0"
              />

              {/* Top Left Card */}
              <div className="absolute top-0 left-0 w-[47%] sm:w-[48%] h-[45%] sm:h-[46%] bg-gradient-to-b from-[#00994C] to-[#005F2F] text-white rounded-[24px] shadow-md flex flex-col items-center justify-center p-5 z-10">
                <img src={iconAutomationWhite} alt="Automation" className="w-8 h-8 mb-4" />
                <h4 className="text-center font-semibold text-base">Industrial Automation</h4>
              </div>

              {/* Top Right Card */}
              <div className="absolute top-0 right-0 w-[47%] sm:w-[48%] h-[45%] sm:h-[46%] bg-white text-[#0052CC] rounded-[24px] shadow-md flex flex-col items-center justify-center p-5 z-10">
                <img src={iconTestingBlue} alt="Testing" className="w-8 h-8 mb-4" />
                <h4 className="text-center font-semibold text-base leading-snug">
                  Assembly &<br />Quality Testing
                </h4>
              </div>

              {/* Bottom Left Card */}
              <div className="absolute bottom-0 left-0 w-[47%] sm:w-[48%] h-[45%] sm:h-[46%] bg-white text-[#0052CC] rounded-[24px] shadow-md flex flex-col items-center justify-center p-5 z-10">
                <img src={iconAutomationBlue} alt="Automation" className="w-8 h-8 mb-4" />
                <h4 className="text-center font-semibold text-base">Industrial Automation</h4>
              </div>

              {/* Bottom Right Card */}
              <div className="absolute bottom-0 right-0 w-[47%] sm:w-[48%] h-[45%] sm:h-[46%] bg-gradient-to-b from-[#00994C] to-[#005F2F] text-white rounded-[24px] shadow-md flex flex-col items-center justify-center p-5 z-10">
                <img src={iconTestingWhite} alt="Testing" className="w-8 h-8 mb-4" />
                <h4 className="text-center font-semibold text-base leading-snug">
                  Assembly &<br />Quality Testing
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto text-center">
          {/* Tagline */}
          <span className="inline-block bg-gray-200 text-gray-800 text-xs font-semibold px-4 py-1 rounded-full uppercase tracking-wide mb-4">
            Why Choose Us
          </span>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Our capabilities
          </h2>

          {/* Description */}
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-16 leading-relaxed">
            We deliver reliable, high-quality manufacturing with advanced technology, expert teams and a strong focus on precision, innovation and on-time delivery.
          </p>

          {/* 3-Card Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {/* Card 1 */}
            <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                Global Standards
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
                We follow internationally recognized quality and safety standards to ensure consistent, world-class output.
              </p>
              <img
                src={globeImg}
                alt="Global Standards"
                className="w-[350px] h-[350px] object-contain"
              />
            </div>

            {/* Card 2 */}
            <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                Smart Manufacturing
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
                Our facilities integrate automation, IoT and data-driven systems for efficient, intelligent production.
              </p>
              <img
                src={smartFactoryImg}
                alt="Smart Manufacturing"
                className="w-[350px] h-[350px] object-contain"
              />
            </div>

            {/* Card 3 */}
            <div className="bg-gray-50 rounded-2xl shadow-md px-6 py-8 flex flex-col items-center text-center h-full">
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                Speed & Scale
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed max-w-xs">
                We deliver high-volume manufacturing with rapid turnaround times—without compromising quality.
              </p>
              <img
                src={chartImg}
                alt="Speed and Scale"
                className="w-[350px] h-[350px] object-contain"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ManufactureHero;      